import * as yup from 'yup';

import { commonCampaignsValidationSchema } from './commonCampaignsValidationSchema';

export const deliveryDiscountFormValidationSchema = commonCampaignsValidationSchema.concat(
  yup.object({
    maxDeliveryDistance: yup.number().required(),
  }),
);
